<div *ngIf="type != 'RX'" class="report-content" [innerHtml]="content | crToBr | safeHtml"></div>
<div *ngIf="type == 'RX'">
    <app-contact-rx-serie [contact]="contact"></app-contact-rx-serie>
</div>